<template>
  <!-- star -->
  <div class="introduction_wrap">
    <navigation></navigation>
    <div class="banner_warp">
      <img class="banner_warp_img" src="../assets/img/huiyun/introduction_banner.png"/>
    </div>

    <!--Introduction to the Group-->
    <div class="group_warp">
      <div class="group_warp_content">
        <h1>集团介绍</h1>
        <h2>INTRODUCTION TO THE GROUP</h2>
        <p>
          奥佳华智能健康科技集团股份有限公司创立于1996年，总部设在厦门。2011年9月9日，在深圳交易所挂牌上市（股票代码：002614.SZ），公司涵盖了保健按摩、健康环境、家用医疗等多个产业模块，是集研发、制造、品牌、营销、服务为一体的国际化智能健康产业集团。公司主导筹建的中医智能推拿按摩健康（中国）院研究，重点从事健康智库、推拿大师手法数字化采集与实现等研究。目前，公司拥有七大产业基地，产品遍及全球80多个国家和地区。集团依托20多年大健康领域经验，布局健康心理领域，慧云品牌由此而生。</p>
      </div>
    </div>

    <!--Introduction to the Company-->
    <div class="company_warp">
      <h1>公司介绍</h1>
      <h2>INTRODUCTION TO THE COMPANY</h2>
      <div class="company_content">
        <img src="../assets/img/huiyun/company_introduction.png"/>
        <div class="company_text">
          <h2>慧云柏科</h2>
          <div class="company_text_line"></div>
          <span>厦门慧云柏科智能科技有限公司是奥佳华集团全资子公司，是一家专业从事心理素质教育软硬件产品研制生产、方案设计、培训交流和学术研究于一体的应用心理学领域的专业机构，可提供心理服务中心一站式整体化解决方案。</span>
          <p>产品品类包含：智慧心理大数据SAAS云平台、生物反馈训练系统、VR虛拟现实训练系统、CSR心理应激评估训练系统、团体脑电心理疏导系统、多维智能击打呐喊宣泄系统等产品。</p>
        </div>
      </div>
    </div>
    <div class="business">
      <div class="business-top"></div>
      <h1>业务覆盖</h1>
      <div class="business-line"></div>
      <div class="business-items">
        <div class="business-item" style=" float: left;">
          <span><img class="business-item-img" src="../assets/img/huiyun/company_army.png"/></span>
          <p class="business-item-text">军队</p>
        </div>
        <div class="business-item" style=" float: left;">
          <span><img class="business-item-img" src="../assets/img/huiyun/company_police.png"/></span>
          <p class="business-item-text">公安</p>
        </div>
        <div class="business-item" style=" float: left;">
          <span><img class="business-item-img" src="../assets/img/huiyun/company_judicial.png"/></span>
          <p class="business-item-text">司法</p>
        </div>
        <div class="business-item" style=" float: left;">
          <span><img class="business-item-img" src="../assets/img/huiyun/company_school.png"/></span>
          <p class="business-item-text">学校</p>
        </div>
        <div class="business-item" style=" float: left;">
          <span><img class="business-item-img" src="../assets/img/huiyun/company_enterprise.png"/></span>
          <p class="business-item-text2">企事业</p>
        </div>
      </div>
    </div>

    <!--Honors-->
    <div class="honors">
      <h1>集团荣誉</h1>
      <h2>QUALIFICATION AND HONOR</h2>
      <div class="honors-content">
        <div class="honors-item">
          <img src="../assets/img/huiyun/group_honor.png">
        </div>
        <div class="honors-item2">
          <img src="../assets/img/huiyun/group_honor2.png">
        </div>
      </div>
    </div>

    <div class="beijing"></div>

    <footer2></footer2>
    <!-- end -->
  </div>
</template>

<script>
import navigation from "../components/nav2.vue";
import footer2 from "../components/footer.vue";

export default {
  name: "contact",
  components: {
    navigation,
    footer2
  },
  data() {
    return {}
  },
  methods: {}
};
</script>
<style scoped>
/*=========================Reset_start==========================*/
/*去内外边距*/
html,
body {
  font-family: "微软雅黑", "宋体", Arail, Tabhoma;
  text-align: left;
}

/*字体 文本居左*/
ul {
  list-style: none;
}

/*去ul li 小点*/
img {
  border: 0 none;
}

/*img IE6 兼容问题*/
input,
select,
textarea {
  outline: 0;
}

/*去除点击蓝框*/
textarea {
  resize: none;
  overflow: auto;
}

/*锁定多行文本框大小 与文字超出出现滚动条*/
table {
  border-collapse: collapse;
  border-spacing: 0;
}

/*表格边框合并 边框间距0*/
th,
strong,
var,
em {
  font-weight: normal;
  font-style: normal;
}

/*特殊文字粗细 样式显示正常*/
a {
  text-decoration: none;
}

/*a标签去下划线*/
.clearfix:after {
  clear: both;
  content: "";
  display: block;
  height: 0;
}

/*清浮动*/
a {
  color: #000000;
}

/*==========================Reset_End===========================*/
.introduction_wrap {
  width: 100vw;
  margin: 0 auto;
}

.banner_warp {
  position: relative;
  width: 1203px;
  height: 364px;
  margin: 0 auto;
}

.banner_warp_img {
  width: 1203px;
  z-index: -999;
  position: absolute;
  height: 364px;
}

.group_warp {
  width: 1920px;
  height: 419px;
  background-image: url("../assets/img/huiyun/group_introduction.png");
  background-size: contain;
}

.group_warp_content {
  /*position: absolute;*/
  /*left: 845px;*/
  /*top: 1110px;*/
  width: 1920px;
  height: 419px;
}

.group_warp_content h1 {
  color: #000000;
  font-weight: 600;
  font-size: 24px;
  padding-top: 110px;
  /*line-height: 80px;*/
  text-align: center;
  font-family: PingFang SC, PingFang SC;
}

.group_warp_content h2 {
  color: #909090;
  font-weight: 500;
  font-size: 16px;
  padding-top: 12px;
  /*line-height: 80px;*/
  text-align: center;
  font-family: PingFang SC, PingFang SC;
}

.group_warp_content p {
  margin-left: 514px;
  width: 867px;
  height: 87px;
  padding-top: 24px;
  /*text-align: center;*/
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  fon-weight: 400;
  color: #1B1B1B;
  line-height: 22px;
}

.company_warp {
  height: 610px;
}

.company_warp h1 {
  color: #000000;
  font-weight: 600;
  font-size: 24px;
  padding-top: 55px;
  /*line-height: 80px;*/
  text-align: center;
  font-family: PingFang SC, PingFang SC;
}

.company_warp h2 {
  color: #909090;
  font-weight: 500;
  font-size: 16px;
  padding-top: 12px;
  /*line-height: 80px;*/
  text-align: center;
  font-family: PingFang SC, PingFang SC;
}

.company_content {
  width: 1920px;
  height: 100%;
  display: flex;
  margin-top: 53px;
}

.company_content img {
  width: 1062px;
  height: 444px;
}

.company_text {
  background: #F9F9F9;
  margin-top: 64px;
  width: 858px;
  height: 380px;
  opacity: 1;
  border-radius: 0px 0px 0px 0px;
}

.company_text h2 {
  margin-top: 94px;
  margin-left: 86px;
  font-size: 18px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  color: #000000;
  line-height: 21px;
  width: 72px;
}

.company_text span {
  width: 614px;
  height: 40px;
  margin-top: 44px;
  margin-left: 86px;
  display: inline-block;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  color: #1B1B1B;
  line-height: 18px;
}

.company_text p {
  width: 546px;
  height: 75px;
  margin-top: 20px;
  margin-left: 86px;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  color: #1B1B1B;
  line-height: 18px;
}

.company_text_line {
  margin-left: 86px;
  margin-top: 23px;
  width: 153px;
  height: 0px;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  border: 1px solid #E0E0E0;
}

.business {
  /*padding-top: 200px;*/
  width: 1920px;
  height: 350px;
  background: #F9F9F9;
}

.business-top {
  width: 1920px;
  padding-top: 80px;
}

.business h1 {
  color: #000000;
  font-size: 18px;
  line-height: 21px;
  text-align: center;
  font-weight: 600;
  font-family: PingFang SC, PingFang SC;
}

.business-line {
  width: 153px;
  height: 0px;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  border: 1px solid #E0E0E0;
  margin: auto;
  margin-top: 21px;
}

.business-items {
  margin: 10px 310px;
  /*margin: 0 auto;*/
  justify-content: space-between;
  /*display: flex;*/
  display: flex;
  width: 1000px;
  height: 180px;
}

.business-item {
  margin-right: 16px;
  position: relative;
  /*width: 180px;*/
  height: 100px;
  background-color: rgba(255, 255, 255, 1);
  /*box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.1);*/
  border-radius: 10px;
}

.business-item span {
  position: absolute;
  left: 120px;
  top: 30px;
  display: inline-block;
  /*border-radius: 100%;*/
  width: 72px;
  height: 72px;
  /*background-color: rgba(52, 145, 229, 1);*/
}

.business-item-img {
  height: 72px;
  width: 72px;
}

.business-item-text {
  position: absolute;
  top: 110px;
  left: 140px;
  width: 100px;
  color: #141414;
  font-weight: 400;
  font-family: PingFang SC, PingFang SC;
  font-size: 18px;
}

.business-item-text2 {
  position: absolute;
  top: 110px;
  left: 130px;
  width: 100px;
  color: #141414;
  font-weight: 400;
  font-family: PingFang SC, PingFang SC;
  font-size: 18px;
}

.honors {
  height: 713px;
  /*width: 1920px;*/
}

.honors h1 {
  color: #000000;
  font-weight: 600;
  font-size: 24px;
  padding-top: 68px;
  /*line-height: 80px;*/
  text-align: center;
  font-family: PingFang SC, PingFang SC;
}

.honors h2 {
  color: #B0B0B0;
  font-weight: 500;
  font-size: 16px;
  padding-top: 12px;
  /*line-height: 80px;*/
  text-align: center;
  font-family: PingFang SC, PingFang SC;
}

.honors-content{
  width: 1600px;
  /*height: 600px;*/
  margin: 0 auto;
  margin-top: 94px;
  /*background-color: red;*/
  display: flex;
}

.honors-item{
  width: 925px;
  height: 403px;
  /*background-color: blue;*/
}

.honors-item img{
  width: 925px;
  height: 403px;
}

.honors-item2{
  padding-top: 100px;
  margin-left: 70px;
  width: 511px;
  height: 212px;
  /*background-color: green;*/
}

.honors-item2 img{
  width: 511px;
  height: 212px;
}

.beijing {
  width: 1920px;
  height: 167px;
  background-image: url("../assets/img/huiyun/beijing_banner.png");
  background-size: contain;
}

</style>
